import { takeEvery } from 'redux-saga/effects';

import * as signUpActions from 'store/modules/auth/signUp';
import { verifyReCaptchaV2 } from './utils';

export default function* listenVerifyReCaptchaV2() {
  yield takeEvery(signUpActions.verifyReCaptchaV2.toString(), verifyReCaptchaV2);
}
